import React, { Component } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Weather from "./Weather";

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="container">
          <Weather defaultCity="Kyiv" />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js